import React from 'react';
import { ListFilter } from 'lucide-react';
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
} from '@/components/ui/select';
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface ChannelFilterProps {
	onChannelChange: (value: string) => void;
	channelFilter: string;
}

export const channelOptions = [
	{ value: 'All', label: 'All channels' },
	{ value: 'sms', label: 'SMS' },
	{ value: 'webchat', label: 'Textchat' },
	{ value: 'facebook', label: 'Facebook' },
	{ value: 'instagram', label: 'Instagram' },
	{ value: 'googleBusinessMessage', label: 'Google' },
];

const ChannelFilter = ({
	onChannelChange,
	channelFilter = 'All',
}: ChannelFilterProps) => {
	const selectedLabel =
		channelOptions.find((opt) => opt.value === channelFilter)?.label ??
		'All channels';
	const isFiltered = channelFilter !== 'All';

	return (
		<Select value={channelFilter} onValueChange={onChannelChange}>
			<Tooltip delayDuration={0}>
				<TooltipTrigger asChild>
					<SelectTrigger
						aria-label={`Channel: ${selectedLabel}`}
						className={cn(
							'h-9 w-9 justify-center px-0 shadow-xs transition-colors [&>svg]:hidden',
							isFiltered && 'border-primary/30 bg-primary/10'
						)}
					>
						<span className="flex">
							<ListFilter
								className={cn(
									'size-4',
									isFiltered
										? 'text-primary'
										: 'text-muted-foreground'
								)}
							/>
						</span>
					</SelectTrigger>
				</TooltipTrigger>
				<TooltipContent>{selectedLabel}</TooltipContent>
			</Tooltip>
			<SelectContent align="end">
				{channelOptions.map((option) => (
					<SelectItem
						key={option.value}
						value={option.value}
						className="text-sm font-medium"
					>
						{option.label}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};

export default ChannelFilter;
